export const globalPadding = 20
export const globalMargin = 16
export const maxPageWidth = 1024

export const navbarHeight = 50
export const navbarMaxWidth = 1200

export const borderRadius = 4
